export const PRESET_NAME_MAX_LENGTH = 200;
